import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const XlIcon = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  "aria-hidden": "true",
  width: "2rem",
  height: "2rem",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M16 9.092c-.67 0-1.22-.549-1.22-1.22V2.997c0-.67.55-1.219 1.22-1.219.671 0 1.22.549 1.22 1.22v4.876c0 .67-.549 1.219-1.22 1.219",
    clipRule: "evenodd",
    opacity: 0.65
  }), /*#__PURE__*/_jsx("path", {
    d: "M19.454 10.012a1.22 1.22 0 0 1-.446-1.664l2.44-4.22a1.225 1.225 0 0 1 1.667-.445 1.22 1.22 0 0 1 .447 1.664l-2.44 4.22c-.336.58-1.086.78-1.668.445",
    clipRule: "evenodd",
    opacity: 0.75
  }), /*#__PURE__*/_jsx("path", {
    d: "M21.982 12.546a1.223 1.223 0 0 1 .447-1.665l4.222-2.438a1.223 1.223 0 0 1 1.666.446c.335.58.134 1.33-.447 1.665l-4.222 2.438a1.223 1.223 0 0 1-1.666-.446",
    clipRule: "evenodd",
    opacity: 0.85
  }), /*#__PURE__*/_jsx("path", {
    d: "M22.908 16c0-.671.548-1.22 1.219-1.22h4.876c.67 0 1.22.549 1.22 1.22s-.55 1.218-1.22 1.218h-4.876c-.67 0-1.22-.548-1.22-1.219",
    clipRule: "evenodd",
    opacity: 0.9
  }), /*#__PURE__*/_jsx("path", {
    d: "M21.982 19.454a1.22 1.22 0 0 1 1.664-.447l4.22 2.44c.58.336.781 1.086.446 1.667a1.22 1.22 0 0 1-1.664.447l-4.22-2.44a1.225 1.225 0 0 1-.446-1.667",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/_jsx("path", {
    d: "M19.454 21.982a1.223 1.223 0 0 1 1.665.446l2.438 4.223c.335.58.135 1.33-.446 1.665-.58.335-1.33.134-1.665-.446l-2.438-4.223a1.223 1.223 0 0 1 .446-1.665",
    clipRule: "evenodd",
    opacity: 0.25
  }), /*#__PURE__*/_jsx("path", {
    d: "M16 22.907c.67 0 1.219.549 1.219 1.22v4.876c0 .67-.549 1.218-1.219 1.218s-1.22-.548-1.22-1.218v-4.877c0-.67.55-1.219 1.22-1.219",
    clipRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.546 21.982c.58.335.781 1.083.446 1.664l-2.438 4.22c-.335.58-1.084.78-1.665.445a1.22 1.22 0 0 1-.446-1.664l2.438-4.22a1.223 1.223 0 0 1 1.665-.445",
    clipRule: "evenodd",
    opacity: 0.35
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.018 19.453c.335.581.134 1.33-.447 1.666L5.35 23.556a1.224 1.224 0 0 1-1.666-.447 1.223 1.223 0 0 1 .447-1.665l4.222-2.438a1.223 1.223 0 0 1 1.666.446",
    clipRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.092 16c0 .67-.549 1.218-1.219 1.218H2.997c-.67 0-1.22-.548-1.22-1.219 0-.67.55-1.219 1.22-1.219h4.876c.67 0 1.22.549 1.22 1.22",
    clipRule: "evenodd",
    opacity: 0.45
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.013 12.55a1.22 1.22 0 0 1-1.664.446l-4.22-2.44a1.225 1.225 0 0 1-.446-1.667 1.22 1.22 0 0 1 1.664-.446l4.22 2.44c.58.336.781 1.086.446 1.667",
    clipRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.546 10.017c-.58.335-1.33.135-1.665-.446L8.443 5.348a1.223 1.223 0 0 1 .446-1.665 1.223 1.223 0 0 1 1.665.446l2.438 4.223c.335.58.135 1.33-.446 1.665",
    clipRule: "evenodd",
    opacity: 0.55
  })]
});
export default XlIcon;